import { createRouter, createWebHistory } from "vue-router";
import { useJwt } from "@vueuse/integrations/useJwt";
import axios from "axios";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import ContactUsSuccess from "../views/ContactUsSuccess.vue";
import RestorePassword from "../views/SetPassword.vue";
import ContactUs from "@/views/ContactUs.vue";
import OidcCallback from "../views/OidcCallback.vue";
import OidcCallbackMicrosoft from "../views/OidcCallbackMicrosoft.vue";
import Time from "../views/Time.vue";
import Delegator from "../views/Delegator.vue";
import Profile from "../views/Profile.vue";
import ExtProfile from "../views/External/Profile.vue";
import Settings from "../views/Settings.vue";
import NewTicket from "@/views/NewTicket.vue";
import TicketsSummary from "@/views/TicketsSummary.vue";
import EditTicket from "@/views/EditTicket.vue";
import FlatFeeCalculator from "@/views/FlatFeeCalculator.vue";
import TicketDetails from "@/views/TicketDetails.vue";
import ViewTickets from "@/views/External/ViewTickets.vue";
import Assets from "@/views/Assets.vue";
import NewSupportTicket from "@/views/External/NewSupportTicket.vue";
import PasswordLogin from "@/views/PasswordLogin.vue";
import SLA from "@/views/SLA.vue";
import AddEditJob from "@/views/AddEditJob.vue";
import UserJobs from "@/views/UserJobs.vue";
import TicketSchedules from "@/views/TicketSchedules.vue";
import AddEditTicketSchedule from "@/views/AddEditTicketSchedule.vue";
import UserAdmin from "@/views/UserAdmin.vue";
import UserAdminEdit from "@/views/UserAdminEdit.vue";
import ReportingIndex from "@/views/Reporting/Index.vue";
import ReportingTicketDetail from "@/views/Reporting/TicketDetail.vue";
import ReportingJobDetail from "@/views/Reporting/JobDetail.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/jobs",
      name: "time",
      component: Time,
      meta: { requiresAuth: true, internalOnly: true, title: "Jobs -  ATMSv2" },
    },
    {
      path: "/job/:jobId?",
      name: "addEditJob",
      component: AddEditJob,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: (to) =>
          to.params.jobId
            ? `Edit Job #${to.params.jobId} - ATMSv2`
            : "Add Job - ATMSv2",
      },
    },
    {
      path: "/jobs/user/:userId?",
      name: "userJobsList",
      component: UserJobs,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "ATMSv2:Jobs of Specific Tech",
      },
    },
    {
      path: "/",
      name: "dashboard",
      meta: { requiresAuth: true, title: "Dashboard -  ATMSv2" },
    },
    // {
    //   path: '/sla',
    //   name: 'SLA',
    //   component: SLA,
    //   meta: { requiresAuth: false }
    // },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { requiresAuth: false, title: "Login -  ATMSv2" },
    },
    {
      path: "/password-login",
      name: "passwordLogin",
      component: PasswordLogin,
      meta: { requiresAuth: false, title: "Password Login -  ATMSv2" },
    },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: Register,
    //   meta: { requiresAuth: false, title: 'Register -  ATMSv2' }
    // },
    {
      path: "/contactUs",
      name: "contactUs",
      component: ContactUs,
      meta: { requiresAuth: false, title: "Contact -  ATMSv2" },
    },
    {
      path: "/contactUs-success",
      name: "contactUsSuccess",
      component: ContactUsSuccess,
      meta: { requiresAuth: false, title: "Contact -  ATMSv2" },
    },
    {
      path: "/forgot",
      name: "forgot",
      component: ForgotPassword,
      meta: { requiresAuth: false, title: "Forgot Password -  ATMSv2" },
    },
    {
      path: "/password-reset",
      name: "setPassword",
      component: RestorePassword,
      meta: { requiresAuth: false, title: "Password Reset -  ATMSv2" },
    },
    {
      path: "/callback",
      name: "oidc-callback",
      component: OidcCallback,
      meta: { requiresAuth: false, title: "OIDC Callback -  ATMSv2" },
    },
    {
      path: "/callback-microsoft",
      name: "oidc-callbackmicrosoft",
      component: OidcCallbackMicrosoft,
      meta: { requiresAuth: false, title: "OIDC Callback -  ATMSv2" },
    },
    {
      path: "/delegator",
      name: "delegator",
      component: Delegator,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Delegator -  ATMSv2",
      },
    },
    {
      path: "/newticket",
      name: "newTicket",
      component: NewTicket,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Create Ticket -  ATMSv2",
      },
    },
    {
      path: "/viewTickets",
      name: "viewTickets",
      component: TicketsSummary,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Tickets Summary -  ATMSv2",
      },
    },
    {
      path: "/viewClientTickets",
      name: "viewClientTickets",
      component: ViewTickets,
      meta: { requiresAuth: true, title: "View Tickets -  ATMSv2" },
    },
    {
      path: "/newSupportTicket",
      name: "newSupportTicket",
      component: NewSupportTicket,
      meta: { requiresAuth: true, title: "Create Support Ticket -  ATMSv2" },
    },
    {
      path: "/editTicket/:id",
      name: "editTicket",
      component: EditTicket,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: (to) => `Edit Ticket #${to.params.id} -  ATMSv2`,
      },
      props: true,
    },
    {
      path: "/ticket/:ticketId",
      name: "ticketDetails",
      component: TicketDetails,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: (to) => `Ticket #${to.params.ticketId} -  ATMSv2`,
      },
      props: true,
    },
    {
      path: "/ticket-schedules",
      name: "ticketSchedules",
      component: TicketSchedules,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Ticket Schedules - ATMSv2",
      },
    },
    {
      path: "/ticket-schedules/new",
      name: "newTicketSchedule",
      component: AddEditTicketSchedule,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Create Ticket Schedule - ATMSv2",
      },
    },
    {
      path: "/ticket-schedules/:id",
      name: "editTicketSchedule",
      component: AddEditTicketSchedule,
      props: true,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: (to) => `Edit Ticket Schedule #${to.params.id} - ATMSv2`,
      },
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Profile -  ATMSv2",
      },
    },
    {
      path: "/extprofile",
      name: "extProfile",
      component: ExtProfile,
      meta: { requiresAuth: true, title: "Profile -  ATMSv2" },
    },
    {
      path: "/admin/users",
      name: "userAdmin",
      component: UserAdmin,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        internalOnly: true,
        title: "User Administration - ATMSv2",
      },
    },
    {
      path: "/admin/users/:id",
      name: "userAdminEdit",
      component: UserAdminEdit,
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        internalOnly: true,
        title: (to) => `Edit User #${to.params.id} - ATMSv2`,
      },
    },
    {
      path: "/settings",
      name: "Settings",
      component: Settings,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Settings -  ATMSv2",
      },
    },
    {
      path: "/network-assets",
      name: "assets",
      component: Assets,
      meta: { requiresAuth: true, title: "Network Assets -  ATMSv2" },
    },
    {
      path: "/feeCalc/",
      name: "feeCalc",
      component: FlatFeeCalculator,
      meta: { requiresAuth: true, internalOnly: true, title: "Fee -  ATMSv2" },
      props: true,
    },
    {
      path: "/reporting",
      name: "reportingAll",
      component: ReportingIndex,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Reporting - ATMSv2",
      },
    },
    {
      path: "/reporting/tickets/:id",
      name: "reportingTicketDetail",
      component: ReportingTicketDetail,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Reporting: Ticket - ATMSv2",
      },
    },
    {
      path: "/reporting/jobs/:id",
      name: "reportingJobDetail",
      component: ReportingJobDetail,
      meta: {
        requiresAuth: true,
        internalOnly: true,
        title: "Reporting: Job - ATMSv2",
      },
    },
  ],
});

// Caller's roles + curated permissions, cached per token so we don't refetch
// on every nav. The `internal` scope is NOT a reliable role gate — it only
// means "has no company", which includes roles 40/50/90 — so we read the
// actual roles.
let _access = { token: null, done: false, roles: [], permissions: [] };
async function fetchAccess(token) {
  if (_access.done && _access.token === token) return _access;
  let roles = [];
  let permissions = [];
  try {
    const uid = localStorage.getItem("user_id");
    const res = await axios.get(`user/role/${uid}`);
    roles = (Array.isArray(res.data?.roles) ? res.data.roles : []).map(Number);
    permissions = Array.isArray(res.data?.user_permissions)
      ? res.data.user_permissions
      : [];
  } catch (e) {
    // fall through with empty access — caller gets redirected, not errored
  }
  _access = { token, done: true, roles, permissions };
  return _access;
}

async function callerIsAdmin(token) {
  const { roles } = await fetchAccess(token);
  return roles.some((r) => [10, 20, 30].includes(r));
}

// Internal/extTech standing comes from the JWT scopes, not the localStorage
// `internal` flag — localStorage is user-editable in dev tools, so the guard
// never trusts it. An undecodable token counts as external (safe default);
// the axios interceptors force a logout on invalid/expired tokens anyway.
function tokenIsInternal(token) {
  if (!token) return false;
  try {
    const { payload } = useJwt(token);
    const scopes = payload.value?.scopes || [];
    return scopes.includes("internal") || scopes.includes("extTech");
  } catch (e) {
    return false;
  }
}

router.beforeEach(async (to, from, next) => {
  const loggedIn = localStorage.getItem("token");
  const isInternal = tokenIsInternal(loggedIn);
  if (to.meta.requiresAuth && !loggedIn) {
    localStorage.setItem(
      "redirectAfterLogin",
      JSON.stringify({
        path: to.fullPath,
      }),
    );
    return next({
      path: "/login",
    });
  }
  if (to.path === "/") {
    if (isInternal) {
      return next("/jobs");
    } else {
      return next("/viewClientTickets");
    }
  }

  // External client roles (scope `external`, e.g. Customer User/Admin) are
  // confined to the client ticket portal — bounce them off any internal-only
  // page. extTech (role 80) carries the extTech scope, counts as internal
  // here, and keeps /jobs access.
  if (to.meta.internalOnly && loggedIn && !isInternal) {
    // /profile has an external counterpart — send them there instead.
    return next(to.path === "/profile" ? "/extprofile" : "/viewClientTickets");
  }

  // Assets is the one internal page external clients may reach: Customer
  // Admin (60) natively, Customer User (70) only with the assets.access
  // grant — same rules as the nav (canSeeAssetsExternal in Navigation.vue).
  if (to.name === "assets" && loggedIn && !isInternal) {
    const { roles, permissions } = await fetchAccess(loggedIn);
    const canSeeAssets =
      roles.includes(60) ||
      (roles.includes(70) &&
        permissions.some(
          (p) =>
            p.module === "assets" &&
            p.name === "access" &&
            String(p.value) !== "0",
        ));
    if (!canSeeAssets) {
      return next("/viewClientTickets");
    }
  }

  if (to.path === "/delegator" && loggedIn) {
    try {
      const { payload } = useJwt(loggedIn);
      const scopes = payload.value?.scopes || [];
      if (scopes.includes("extTech") && !scopes.includes("internal")) {
        return next("/jobs");
      }
    } catch (e) {
      // fall through if token can't be decoded — beforeEach handles invalid tokens elsewhere
    }
  }

  // User administration is restricted to internal admins (roles 10/20/30).
  if (to.meta.requiresAdmin && loggedIn) {
    const ok = await callerIsAdmin(loggedIn);
    if (!ok) {
      return next(isInternal ? "/jobs" : "/viewClientTickets");
    }
  }

  // "Jobs of a specific tech" is restricted to internal admins (roles 10/20/30),
  // the same set as user administration. Mirrors the backend gate on
  // POST /api/job/filtered/userjobs (roles:10,20,30).
  if (to.name === "userJobsList" && loggedIn) {
    const ok = await callerIsAdmin(loggedIn);
    if (!ok) {
      return next(isInternal ? "/jobs" : "/viewClientTickets");
    }
  }

  next();
});

const DEFAULT_TITLE = "ATMSv2 - AIM IT Services";
router.afterEach((to) => {
  const match = [...to.matched].reverse().find((r) => r.meta?.title);

  let title = DEFAULT_TITLE;
  if (match) {
    title =
      typeof match.meta.title === "function"
        ? match.meta.title(to)
        : match.meta.title;
  }

  document.title = title || DEFAULT_TITLE;
});
export default router;
